import { useSyncExternalStore } from 'react'
import type * as Y from 'yjs'
import { yCustomNodeDatas } from '@/shared/config/yjs-config'

export function useNodeCustomMap(nodeId: string): Y.Map<unknown> | null {
  const subscribe = (onStoreChange: () => void) => {
    const observer = (event: Y.YMapEvent<Y.Map<unknown>>) => {
      if (event.keysChanged.has(nodeId)) {
        onStoreChange()
      }
    }

    yCustomNodeDatas.observe(observer)
    return () => yCustomNodeDatas.unobserve(observer)
  }

  return useSyncExternalStore(
    subscribe,
    () => (yCustomNodeDatas.get(nodeId) as Y.Map<unknown>) ?? null,
  )
}
